import * as React from 'react';
import ManutationPanel from '../manutationpanel';

export function CltManutation() {
  return (<div style={{ textAlign: 'center' }}>
    <ManutationPanel
      endpointBase="/server/cltCommand/botManutation"
      systemLabel="CLT"
      showShot
      shotDisabled
    />
  </div>);
}
